import { render, staticRenderFns } from "./RecentResults.vue?vue&type=template&id=430fb695&scoped=true&"
import script from "./RecentResults.vue?vue&type=script&lang=js&"
export * from "./RecentResults.vue?vue&type=script&lang=js&"
import style0 from "./RecentResults.vue?vue&type=style&index=0&id=430fb695&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "430fb695",
  null
  
)

export default component.exports